<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">COMMANDO HELICOPTER AIRCREWMAN</h1>
<p class="titlea">51 Years in Action with the RN and RAF</p>
<p class="titleb">John Sheldon</p>
<div class="image_containerf">
<img alt="images" src="images/f0iii-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?7ab7c811